var scrollAnimate = require("./components/scrollAnimate");

$(document).ready(function () {
    $(".button-component-pd__link[href^='#']").on("click", function (e) {
        e.preventDefault();

        if ($(this).data("toggle") !== "modal") {
            const sectionID = $(this).attr("href");
        
            scrollAnimate($(sectionID));
        }
    });
});
